import React from "react";
import Radio from "antd/lib/radio";
import {
  SurveyQuestionCard,
  SymptomAlertCard,
  AnswerList,
  AnswerOption,
  FormItemStyle,
  AsteriskStyle,
  CardTitle
} from "pages/symptoms/surveyForms/surveyFormComponents";

interface WeightGainSectionProps {
  readonly currentPage: number;
}

export const WeightGainSection: React.FC<WeightGainSectionProps> = ({
  currentPage
}) => {
  return (
    <>
      {currentPage === 14 && (
        <SurveyQuestionCard
          sectionTag="WEIGHT GAIN"
          title="How much weight do you gain between dialysis treatments?"
          required
        >
          <FormItemStyle
            name="How much weight do you gain"
            label=""
            rules={[{ required: true }]}
            initialValue={""}
          >
            <Radio.Group
              value={localStorage.getItem("howMuchWeightDoYouGain")}
              onChange={e => {
                localStorage.setItem("howMuchWeightDoYouGain", e.target.value);
              }}
            >
              <AnswerList>
                <AnswerOption value="None">None</AnswerOption>
                <AnswerOption value="Less than 2 kilograms (4 pounds)">
                  Less than 2 kilograms (4 pounds)
                </AnswerOption>
                <AnswerOption value="2 - 3 kilograms (4 - 7 pounds)">
                  2 - 3 kilograms (4 - 7 pounds)
                </AnswerOption>
                <AnswerOption value="3 - 5 kilograms (7 - 11 pounds)">
                  3 - 5 kilograms (7 - 11 pounds)
                </AnswerOption>
                <AnswerOption value="More than 5 kilograms">
                  More than 5 kilograms
                </AnswerOption>
              </AnswerList>
            </Radio.Group>
          </FormItemStyle>
        </SurveyQuestionCard>
      )}
      {currentPage === 15 && (
        <SymptomAlertCard message="Please discuss your symptoms of weight gain with your nurse or doctor and dietician, regarding dietary sodium restriction, and other treatment changes" />
      )}
    </>
  );
};
